export class OnsetExamResultDto {
    bookingId: number;
    variantId: number;
    startLevel: number;
    endLevel: number;
}
